export default {
  alquant: {
    faq: {
      howToInvest: {
        question: "Wie kann ich in eines von Alquants Produkten investieren?",
        answer:
          'Da die finanzielle Situation und das Risikoprofil eines jeden Anlegers unterschiedlich sind, müssen wir Ihre Situation bewerten und prüfen, ob eines unserer Produkte für Sie geeignet ist. Um dies zu tun, verwenden Sie bitte <a href="/help/contact">unser Kontaktformular</a> oder schicken Sie uns eine E-Mail an <a href="mailto:info@alquant.com">info@alquant.com</a>, um eine Diskussion zu beginnen oder einen Anruf mit uns zu vereinbaren. Wir helfen Ihnen gerne weiter.',
      },
      moreQuestions: {
        question: "Ich habe eine weitere Frage, wo kann ich sie stellen?",
        answer:
          'Sie können uns jederzeit über <a href="/help/contact">unser Kontaktformular</a> kontaktieren, um Fragen zu stellen. Sie können innerhalb von 1-2 Werktagen eine Antwort von uns erwarten.',
      },
      whatAlquant: {
        question: "Was ist Alquant?",
        answer:
          'Alquant ist eine Schweizer Vermögensverwaltungsgesellschaft, die sich auf Risikomanagement spezialisiert hat und die traditionelle Vermögensverwaltung durch quantitative Finanzen und künstliche Intelligenz zum Vorteil ihrer Kunden verbessert. Wir sind bestrebt, überlegene Anlageergebnisse und herausragende Anlegererfahrungen zu erzielen. Weitere Informationen finden Sie auf unserer Website: <a href="https://alquant.com" target="_blank">https://alquant.com</a>.',
      },
      whatGoal: {
        question: "Was ist das Ziel dieser Plattform?",
        answer:
          "Da Alquant sich verpflichtet hat, eine hohe Transparenz und ein herausragendes Anlegererlebnis zu bieten, möchten wir, dass unsere Kunden Zugang zu interaktiven Diagrammen mit täglich aktualisierten Werten haben, anstatt langweilige PDF-Dokumente, die einmal im Monat erstellt werden, um zu sehen, wie unsere Produkte performen.",
      },
    },
  },
  bcf: {
    redirectButtonNavBarText: "Zurück zur Startseite",
  },
  bonhote: {
    redirectButtonNavBarText: "Zurück zur Hauptseite",
    categories: {
      portfolios: "Modell-Pensionsportfolios",
    },
  },
  calmgard: {
    nextSubscriptionAndRedemption: {
      nextRedemption: (ctx) =>
        `<b>Rücknahmen</b>, die vor dem ${ctx.named(
          "date"
        )} um 12:00 Uhr MEZ erfolgen, werden zum letzten NAV des Monats ${ctx.named(
          "month"
        )} ausgeführt.`,
      nextSubscription: (ctx) =>
        `<b>Zeichnungen</b>, die vor dem ${ctx.named(
          "date"
        )} um 12:00 Uhr MEZ erfolgen, werden zum letzten NAV des Monats ${ctx.named(
          "month"
        )} ausgeführt.`,
      title: "Nächste mögliche Handelsdaten",
    },
  },
  cronos: {
    redirectButtonNavBarText: "Startseite Cronos",
  },
  demo: {
    customSections: {
      useCases: {
        title: "Anwendungsfälle",
        alpinum: {
          strategyName: "Alpinum",
          title: "Alpinum",
          historicalResults: {
            title: "Historische Ergebnisse",
            biggestDrawdowns: {
              title: (ctx) => `Größte Drawdowns von ${ctx.named("benchmark")}`,
            },
            drawdowns: {
              title: "Drawdowns",
            },
          },
          metaInfo: {
            title: "Anwendungsfall - Alpinum",
          },
          parameters: {
            runButton: "Anwendungsfall ausführen",
            benchmark: "Benchmark",
            title: "Parameter",
          },
        },
      },
    },
  },
  hqam: {
    categories: {
      funds: "Fonds",
      certificates: "Zertifikate",
      composites: "Komposite",
    },
  },
  lakefield: {
    proposalTool: {
      sectionName: "Proposal-Tool",
      reportGenerationSubSectionName: "Berichterstellung",
      weightOptimizationSubSectionName: "Gewichtsoptimierung",
      dataIntegritySubSectionName: "Datenintegrität",
      historicalAssetAllocationSubSectionName: "Historische Vermögensallokation",
      pages: {
        benchmark: "Benchmark",
        avg: "Durchschnitt",
        max: "Max",
        min: "Min",
        timePeriod: (ctx) => `Zeitraum: ${ctx.named("periodStart")} bis ${ctx.named("periodEnd")}`,
        netOfFees: "netto nach Gebühren",
        grossOfFees: "brutto nach Gebühren",
        assetClass: {
          cashAndEqui: "Bargeld & Äquivalente",
          fixedIncome: "Festverzinsliche Wertpapiere",
          equity: "Aktien",
          altInvest: "Alternative Investitionen",
        },
        graph: {
          range: {
            minMax: "Min-Max",
            current: "Aktuell",
          },
          verticalBar: {
            monthRets: "Monatliche Renditen (%)",
            freqMonthRets: "Häufigkeit der monatlichen Renditen (%)",
          },
        },
        riskClassification: {
          cons: "Konservativ",
          // For convenience, keep the white space after the dash.
          modCons: "Moderat- Konservativ",
          mod: "Moderat",
          // For convenience, keep the white space after the dash.
          modAgg: "Moderat- Aggressiv",
          agg: "Aggressiv",
        },
        strategyReport: {
          strategyName: (ctx) =>
            `Strategiename: ${ctx.named("portfolioName")} (${ctx.named("currency")})`,
          forConsiderationOf: (ctx) => `Zur Kenntnisnahme für: ${ctx.named("recipient")}`,
          preparedBy: (ctx) => `Erstellt von: ${ctx.named("author")}`,
          preparedByAndOn: (ctx) =>
            `Erstellt von: ${ctx.named("author")}, am ${ctx.named("createdAsOf")}`,
          preparedOn: (ctx) => `Erstellt am: ${ctx.named("createdAsOf")}`,
          dataAsOf: (ctx) => `Daten per: ${ctx.named("periodEnd")}`,
        },
        tableOfContents: {
          title: "Inhaltsverzeichnis",
        },
        executiveSummary: {
          title: "Zusammenfassung",
          benchmarkDescription: "Benchmark-Beschreibung",
          perfChara: {
            title: "Leistungsmerkmale",
            cumReturn: "Kumulative Rendite (%)",
            annualReturn: "Jährliche Rendite (%)",
            volatility: "Volatilität (%)",
            sharpeRatio: (ctx) => `Sharpe Ratio (risikofrei: ${ctx.named("annualizedRfRates")})`,
            maxDrawdown: "Maximaler Drawdown (%)",
          },
          partnersFees: {
            title: "Gebühren von Lakefield Partners",
            managmtFees: "Verwaltungsgebühr (%, pro Jahr, vierteljährlich verrechnet)",
            perfFee: "Performancegebühr",
            propWithPerfFee: "Anteil des Portfolios mit Performancegebühr (%)",
            perfFeeComp: "Komponenten der Performancegebühr:",
            percentOfPortfolio: "% des Portfolios",
            perfFeePercent: "Perf.-Gebühr (%)",
            hwm: "HWM",
            description: "Beschreibung",
            absoluteAndNoHurlde: "Absolut, keine Hurdle Rate",
            relativeToBenchmarkSli: (ctx) =>
              `Relativ zum Benchmark (SLI TR ${ctx.named("currency")}, keine Hurdle Rate`,
            perfFeeCrystalized: "Performancegebühr: jährlich kristallisiert und verrechnet",
            hwmLong: "HWM: High-Water-Mark",
          },
          portfolioChara: {
            title: "Portfoliomerkmale",
            refCurrency: "Referenzwährung",
            expectedPortfolioSize: "Erwartete Portfoliogröße",
            assetCoverage: "Anlagenabdeckung",
            multiAsset: "Multi-Asset",
            assetAllocRanges: "Bandbreiten der Vermögensallokation:",
            regionalCoverage: "Regionale Abdeckung",
            globalSwiss: "Global/Schweiz",
            riskClass: "Risikoklassifizierung",
          },
          custodianBankInfo: {
            title: "Informationen zur Depotbank",
            avaialableCustodianBank: "Verfügbare Depotbank(en)",
            custodianFees: "Depotgebühren",
          },
        },
        portfolioComposition: {
          title: "Portfoliozusammensetzung",
          assetAlloc: "Vermögensallokation",
          strategyAlloc: {
            title: "Strategieallokation",
            coreAlloc: "Kernallokation",
            satelliteAlloc: "Satellitenallokation",
            total: "Gesamt",
          },
          assetAllocRanges: "Bandbreiten der Vermögensallokation (%)",
          histAssetAlloc: "Historische Vermögensallokation (%)",
        },
        performanceAnalysis: {
          title: "Performanceanalyse",
          investGrowth: "Anlagewachstum",
          keyPerfStats: {
            title: "Wichtige Leistungsstatistiken",
            currency: "Währung",
            cumReturn: "Kumulative Rendite (%)",
            annualReturn: "Jährliche Rendite (%)",
            volatility: "Volatilität (%)",
            sharpeRatio: (ctx) => `Sharpe Ratio (risikofrei: ${ctx.named("annualizedRfRates")})`,
            maxDrawdown: "Maximaler Drawdown (%)",
          },
          histYearyRets: "Historische jährliche Renditen",
          histMonthRets: "Historische monatliche Renditen",
        },
        riskAnalysis: {
          title: "Risikoanalyse",
          drawdownAnalysis: "Drawdown-Analyse",
          drawdownTable: {
            title: "Drawdown-Tabelle",
            drawdownRank: "Drawdown-Rang",
            drawdown: "Drawdown (%)",
            startDate: "Startdatum",
            bottomDate: "Unteres Datum",
            endDate: "Enddatum",
          },
          riskMetrics: {
            title: "Risikokennzahlen",
            volatility: "Volatilität (%)",
            sharpeRatio: (ctx) => `Sharpe Ratio (risikofrei: ${ctx.named("annualizedRfRates")})`,
            sortinoRatio: (ctx) => `Sortino Ratio (risikofrei: ${ctx.named("annualizedRfRates")})`,
            maxDrawdown: "Maximaler Drawdown (%)",
          },
          distribMonthlyRets: "Verteilung der monatlichen Renditen",
          riskCat: "Risikokategorisierung",
        },
        portfolioHoldings: {
          title: "Portfoliobestände",
          assetAlloc: "Vermögensallokation",
          currencyAlloc: "Währungsallokation",
          fixedIncomSectors: "Sektoren festverzinsliche Anlagen",
          equitySectors: "Aktiensektoren",
          topHoldings: {
            title: "Top-Positionen",
            name: "Name",
            isin: "ISIN",
            currency: "Währung",
            assetClass: "Anlageklasse",
            sector: "Sektor",
            region: "Region",
            weight: "Gewicht",
          },
        },
        glossaryOfTechTerms: {
          title: "Haftungsausschluss",
          subTitle: "Glossar der Fachbegriffe",
          glossary: {
            expectedShortfall: {
              title: "Expected Shortfall",
              text: 'Auch bekannt als Conditional Value at Risk (CVaR), ist der Expected Shortfall eine Risikobewertungsmassnahme, die das Ausmass des Tail-Risikos eines Anlageportfolios quantifiziert. Der Expected Shortfall wird durch die Bildung eines gewichteten Durchschnitts der "extremen" Verluste im Endbereich der Verteilung möglicher Renditen, jenseits eines kritischen Grenzwertes, der typischerweise als das 95. Perzentil der historischen Rendite definiert ist, abgeleitet. Der Expected Shortfall wird bei der Portfoliooptimierung für ein effektives Risikomanagement verwendet.',
            },
            hwm: {
              title: 'High-Water-Mark ("HWM")',
              text: "Die High-Water-Mark ist der höchste Wert, den ein Anlagefonds oder ein Konto je erreicht hat. Dieser Begriff wird häufig im Zusammenhang mit der Vergütung von Vermögensverwaltern verwendet, die leistungsabhängig ist. Wenn der Manager über einen bestimmten Zeitraum Geld verliert, muss er den Fonds über die High-Water-Mark bringen, bevor er einen Leistungsbonus aus dem verwalteten Vermögen (AUM) erhält.",
            },
            maxDrawdown: {
              title: "Maximaler Drawdown",
              text: "Der maximale Drawdown (MDD) ist der maximal beobachtete Verlust von einem Höchststand zu einem Tiefststand eines Portfolios oder einer Strategie, bevor ein neuer Höchststand erreicht wird. Der maximale Drawdown ist ein Indikator für das Abwärtsrisiko über einen bestimmten Zeitraum.",
            },
            semiVolatility: {
              title: "Semi-Volatilität",
              text: 'Auch als "Downside Deviation" bekannt, ist die Semi-Volatilität ein Mass für das Abwärtsrisiko, das sich auf Renditen konzentriert, die unter einen Mindestschwellenwert fallen, in unserem Fall eine Nullrendite. Sie wird bei der Berechnung der Sortino Ratio verwendet, einem Mass für die risikobereinigte Rendite. Die Sortino Ratio ähnelt der Sharpe Ratio, mit dem Unterschied, dass sie die Standardabweichung (Volatilität) durch die Downside Deviation (Semi-Volatilität) ersetzt.',
            },
            sharpeRatio: {
              title: "Sharpe Ratio",
              text: "Die Sharpe Ratio wurde vom Nobelpreisträger William F. Sharpe entwickelt und wird verwendet, um Anlegern zu helfen, die Rendite einer Anlage im Verhältnis zu ihrem Risiko zu verstehen. Das Verhältnis ist die durchschnittliche Rendite, die über dem risikofreien Zinssatz pro Einheit Volatilität oder Gesamtrisiko erzielt wird. Volatilität ist ein Mass für die Preisschwankungen eines Vermögenswertes oder Portfolios. Im Allgemeinen gilt: Je höher der Wert der Sharpe Ratio, desto attraktiver die risikobereinigte Rendite.",
            },
            sortinoRatio: {
              title: "Sortino Ratio",
              text: "Die Sortino Ratio, benannt nach Frank A. Sortino, ist eine Variante der Sharpe Ratio, die zwischen schädlicher Volatilität und der Gesamtvolatilität unterscheidet, indem sie die Standardabweichung der negativen Portfoliorenditen - die Downside Deviation - anstelle der gesamten Standardabweichung der Portfoliorenditen verwendet. Je höher der Wert der Sortino Ratio, desto attraktiver ist die risikobereinigte Rendite.",
            },
            volatility: {
              title: "Volatilität",
              text: 'Volatilität ist ein statistisches Mass für die Streuung der Renditen eines bestimmten Wertpapiers oder einer Strategie. Je höher die Volatilität, desto riskanter die Strategie. Die Volatilität wird als die annualisierte Standardabweichung der Strategierrenditen gemessen. An den Wertpapiermärkten wird Volatilität oft mit grossen Schwankungen in beide Richtungen in Verbindung gebracht. Wenn zum Beispiel der Aktienmarkt über einen längeren Zeitraum um mehr als ein Prozent steigt und fällt, spricht man von einem "volatilen" Markt.',
            },
          },
          disclaimer: {
            para1:
              "Dieses Dokument und die darin enthaltenen Informationen dienen Werbe- und Informationszwecken. Der Inhalt dieses Dokuments wurde von der Lakefield Partners AG mit grösster Sorgfalt und nach bestem Wissen und Gewissen erstellt. Die Lakefield Partners AG übernimmt jedoch keine Gewähr für deren Inhalt und Vollständigkeit und lehnt jede Haftung für Verluste ab, die sich aus der Verwendung dieser Informationen ergeben könnten. Die zur Verfügung gestellten Informationen dienen nur zu Informationszwecken und sind für den ausschliesslichen Gebrauch des Empfängers bestimmt. Dieses Dokument darf ohne die schriftliche Genehmigung der Lakefield Partners AG für keinen Zweck vervielfältigt, weiterverbreitet oder wiederveröffentlicht werden.",
            para2:
              "Die hierin erwähnten Informationen sind nicht als Aufforderung oder Angebot zum Kauf oder Verkauf von Wertpapieren, damit verbundenen Finanzinstrumenten oder zur Durchführung anderer Transaktionen zu verstehen. Der Inhalt dieses Dokuments ist nicht als Anlage-, Rechts- oder Steuerberatung auszulegen. Die Informationen in diesem Dokument sind nicht für US-Personen (im Sinne der Regulation S des US Securities Act von 1933 in ihrer jeweils gültigen Fassung) bestimmt, noch für Personen, die einer Rechtsordnung unterliegen, die den Zugang zu oder die Veröffentlichung dieses Dokuments verbietet (aufgrund der Nationalität, des Wohnsitzes oder aus anderen Gründen). Personen, die lokalen Beschränkungen unterliegen, ist der Zugang zu diesem Dokument untersagt.",
            para3:
              "Jede Anlage ist mit Risiken verbunden, insbesondere im Hinblick auf Wert- und Renditeschwankungen. Anlagen in Fremdwährungen bergen das zusätzliche Risiko, dass die Fremdwährung gegenüber der Referenzwährung des Anlegers an Wert verliert. Es ist zu beachten, dass historische Renditen keine Garantie für die zukünftige Performance sind. Darüber hinaus gibt es keine Garantie dafür, dass die Performance des Referenzindex oder der Benchmark erreicht oder übertroffen wird. Des Weiteren berücksichtigt diese Information keine spezifischen oder zukünftigen Anlageziele, keine finanzielle oder steuerliche Situation oder besondere Bedürfnisse eines bestimmten Empfängers.",
            para4:
              "Für Erläuterungen und Klarstellungen zu den einzelnen Performances wird auf die Factsheets der jeweiligen Komponentenstrategien verwiesen. Die Performance kann teilweise simuliert sein, um die Eigenschaften einer Strategie zu veranschaulichen. Die Zusammensetzung und die Portfoliomerkmale können während oder nach der Umsetzung erheblich von den hier gezeigten abweichen.",
            para5:
              "Bitte lesen Sie den Prospekt bzw. die Produktinformationen für den Fonds und das KIID/KID sorgfältig durch, bevor Sie Ihre endgültige Anlageentscheidung treffen. Alle Angebotsunterlagen, d.h. der Prospekt bzw. Platzierungsprospekt, das Key Investor Information Document (KIID), das Key Information Document (KID), die Vertragsbedingungen der Fonds sowie die Jahres- und Halbjahresberichte sind, sofern verfügbar, kostenlos bei der Lakefield Partners AG, Seefeldstrasse 281, 8008 Zürich oder unter https://www.fundinfo.com erhältlich.",
            para6:
              "Kundeninformationen gemäss Finanzdienstleistungsgesetz (FIDLEG) Basierend auf den gesetzlichen Anforderungen des Finanzdienstleistungsgesetzes (FIDLEG) gibt der folgende Link einen Überblick über die Lakefield Partners AG und ihre Dienstleistungen. https://www.lakefieldpartners.com/de/regulatory-information/",
          },
        },
      },
      report: {
        backToInputs: "Zurück zur Eingabe",
        downloadReport: "Bericht herunterladen",
        taskFailed: (ctx) =>
          `Aufgabe ${ctx.named("taskName")} fehlgeschlagen: ${ctx.named("reason")}`,
      },
      reportInputs: {
        generateReport: "Bericht erstellen",
        checkDataIntegrity: "Datenintegrität prüfen",
        reportName: {
          strategyReport: "Strategiebericht",
          investmentProposal: "Anlagevorschlag",
        },
        fields: {
          general: {
            title: "Allgemein",
            portfolioName: "Portfolioname",
            portfolioNamePlaceholder:
              "Zum Suchen oder Hinzufügen eines benutzerdefinierten Namens eingeben",
            reportName: "Berichtsname",
            author: "Autor",
            recipient: "Empfänger",
            createdAsOf: "Erstellt am",
            currency: "Währung",
            startingValue: "Anfangswert",
            portfolioNameSections: {
              clientSolutions: "Kundenlösungen",
              pensionSolutions: "Altersvorsorgelösungen",
              cornerstoneStrategies: "Grundlegende Strategien",
            },
          },
          executiveSummary: {
            title: "Zusammenfassung",
            availableCustodian: "Verfügbare Depotbank(en)",
            textSection: "Textabschnitt",
            textSectionTitle: "Titel",
            textSectionContent: "Inhalt",
          },
          composition: {
            title: "Zusammensetzung",
            lakefieldProducts: "Lakefield-Produkte",
            product: "Produkt",
            currency: "Währung",
            availableUntil: "Verfügbar bis",
            period: "Zeitraum",
            weight: "Gewicht (%)",
            addProduct: "Produkt hinzufügen",
            hedgeIsSynthetic:
              "Eine der Komponenten der Strategie ist in der ausgewählten Währung nicht verfügbar. Bitte holen Sie eine interne Genehmigung ein.",
            satellites: "Satelliten",
            satellite: "Satellit",
            addSatellite: "Satellit hinzufügen",
            singleSatelliteWeightWarning:
              "Das Gewicht eines einzelnen Satelliten überschreitet 10 %. Bitte holen Sie eine interne Genehmigung ein.",
            aggregatedSatelliteWeightsWarning:
              "Die Gesamtgewichte der Satelliten überschreiten 30 %. Bitte holen Sie eine interne Genehmigung ein.",
            total: "Total",
            selectOneProduct:
              "Wählen Sie mindestens ein Produkt in der Zusammensetzung aus, um einen Zeitraum auswählen zu können.",
          },
          fees: {
            title: "Gebühren",
            custodianFees: "Depotgebühren (in %)",
            expectedPortfolioSize: "Erwartete Portfoliogröße",
            feeBasis: "Gebührenbasis",
            feeBasisGross: "Brutto",
            feeBasisNet: "Netto",
            custodianFeesDefault: "Gesamtgebühr 0,15 % p. a. + CHF 100 Ticketgebühr",
            overridenFixedFees: "Überschriebene Fixgebühren (in %)",
            overridenFixedFeesCantSetWithGross:
              "Bei Verwendung der Bruttogebührenbasis kann kein Rabatt gewährt werden",
            overridenFixedFeesCantSetWithLowAum:
              "Ein Rabatt setzt eine erwartete Portfoliogröße von mindestens 5 Millionen voraus.",
            overridenFixedFeesWarning:
              "Auf den Preis wird ein Rabatt gewährt. Bitte holen Sie eine interne Genehmigung ein.",
            withPerfFees: "Mit Performancegebühren",
          },
          benchmark: {
            title: "Benchmark",
            selection: "Auswahl",
            selectionStandard: "Standard",
            selectionAlternative: "Alternative",
            selectionNone: "Keine",
            benchmark: "Benchmark",
            currency: "Währung",
            availableUntil: "Verfügbar bis",
            weight: "Gewichtung (%)",
            addBenchmark: "Benchmark hinzufügen",
            doNotAbuse:
              "Benutzer werden gebeten, diese Funktion nicht zu missbrauchen, indem sie Benchmarks erstellen, die keine faire und genaue Darstellung der Produktzusammensetzung widerspiegeln.",
          },
          pagesSelection: {
            title: "Seitenauswahl",
            page: {
              portfolioHoldingsChart: "Portfoliobestände (Diagramme)",
              portfolioHoldingsList: "Portfoliobestände (Liste)",
            },
          },
          miscellanous: {
            title: "Verschiedenes",
            numMonthlyReturns: "Anzahl Jahre für historische monatliche Renditen",
            numTopHoldings: "Anzahl der Positionen für Top-Positionen",
            numTopHoldingsTooltip: "[WIP] Leer lassen, um alle Positionen zu erhalten.",
          },
        },
      },
      weightOptimization: {
        portfoliosWeightsAllocation: "Gewichtung der Portfolios",
        core: "Kern",
        addProduct: "Produkt hinzufügen",
        satellite: "Satellit",
        addSatellite: "Satellit hinzufügen",
        total: "Gesamt",
        chartsAndTables: {
          buttonText: "Diagramme und Tabellen erzeugen",
          dataLoadError:
            "Beim Laden der Daten ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie Alquant AG, falls das Problem weiterhin besteht.",
          drawdowns: "Drawdowns",
          performance: "Performance",
          period: "Zeitraum",
          periodSelectionCondition:
            "Stellen Sie sicher, dass jede Komponente mit einem nicht-null Gewicht in einem beliebigen Portfolio einen ausgewaehlten Namen und eine Währung hat.",
          returnToRiskSpace: "Rückkehr zum Risikoraum",
          selectedPortfolios: "Ausgewählte Portfolios",
          statistics: "Statistiken",
          year: "Jahr",
          yearlyReturns: "Jährliche Renditen",
        },
        actionTooltip: {
          restoreDefaultPortfolio: (ctx) =>
            `Auf die Standard-Allokation für '${ctx.named("portfolioName")}' zurücksetzen.`,
          cantRestoreDefaultPortfolio: "Das Portfolio entspricht bereits der Standard-Allokation.",
          optimizeWeight: (ctx) =>
            `Gewichtung für '${ctx.named("portfolioName")}' basierend auf Einschränkungen und Zielen optimieren.`,
          cantOptimizeWeight:
            "Für die Optimierung sind gültige Symbole und Währungen für alle Positionen sowie mindestens eine Core- oder Satellite-Position erforderlich.",
          usePortfolioToGenerateReport: (ctx) =>
            `Einen Bericht für das Portfolio '${ctx.named("portfolioName")}' generieren.`,
          cantGenerateReport:
            "Für die Berichterstellung sind gültige Symbole und Währungen sowie eine Gesamtallokation von exakt 100% erforderlich.",
        },
        optimizationDialog: {
          title: "Optimierungseinstellungen",
          objective: "Zielsetzung",
          period: "Optimierungszeitraum",
          bounds: "Allokationsgrenzen",
          min: "Min",
          max: "Max",
          buttonText: "Optimierung starten",
          optimization: {
            minVolWithTargetMinRet: {
              name: "Volatilität minimieren (Zielrendite)",
              targetTitle: "Mindestjahresrendite",
            },
            maxRetWithTargetMaxVol: {
              name: "Rendite maximieren (Zielvolatilität)",
              targetTitle: "Maximale Jahresvolatilität",
            },
            maxRetWithTargetMaxDrawdown: {
              name: "Rendite maximieren (Ziel-Drawdown)",
              targetTitle: "Maximaler Drawdown",
            },
            maxReturn: {
              name: "Rendite maximieren",
            },
            maxSharpe: {
              name: "Sharpe-Ratio maximieren",
            },
            maxSortino: {
              name: "Sortino-Ratio maximieren",
            },
            minVol: {
              name: "Volatilität minimieren",
            },
            minDrawdown: {
              name: "Maximalen Drawdown minimieren",
            },
          },
        },
        failedOptimizationDialog: {
          title: "Optimierung fehlgeschlagen",
          text: "Keine Lösung gefunden. Die Einschränkungen (Zielwerte und Allokationsgrenzen) sind möglicherweise zu strikt.",
        },
      },
      dataIntegrity: {
        loadingData: "Daten werden geladen ...",
        exportToExcel: "Export nach Excel",
        noSymbolSelected: (ctx) => `Kein Symbol für "${ctx.named("group")}" ausgewählt.`,
        group: {
          core: "Kernanlage (Core)",
          satellite: "Satellitenanlage (Satellite)",
          benchmark: "Benchmark",
          cash: "Bargeld",
          forex: "Devisen",
        },
        multiselect: {
          placeholder: "Symbol auswählen",
          selectLabel: "Eingabetaste zum Auswählen",
          deselectLabel: "Eingabetaste zum Entfernen",
          selectedLabel: "Ausgewählt",
          selectGroupLabel: "Eingabetaste zum Auswählen der Gruppe",
          deselectGroupLabel: "Eingabetaste zum Abwählen der Gruppe",
          limitText: (ctx) => `und ${ctx.named("count")} weitere`,
        },
      },
      historicalAssetAllocation: {
        title: "Verwaltung der historischen Asset-Allokation",
        description:
          "Um die Daten zu aktualisieren, exportieren Sie die aktuelle CSV-Datei, passen Sie die Werte an und importieren Sie die überarbeitete Datei.",
        button: {
          exportCurrentAllocation: "Aktuelle Allokation exportieren",
          importNewAllocation: "Neue Allokation importieren",
        },
        export: {
          unexpectedError: {
            title: "Unerwarteter Fehler",
            text: "Bei der Verarbeitung Ihrer Datei ist ein unerwarteter Fehler aufgetreten. Bitte kontaktieren Sie das Alquant-Team für Unterstützung.",
          },
        },
        import: {
          importSuccessText: "Historische Asset-Allokation erfolgreich aktualisiert.",
          importErrorText:
            "Die historische Vermögensaufteilung konnte nicht aktualisiert werden. Bitte wenden Sie sich an das Alquant-Team, um Unterstützung zu erhalten.",
          exceedSize: {
            title: "Datei zu groß",
            text: "Die hochgeladene Datei überschreitet 1&nbsp;MB. Dies sollte eigentlich nicht möglich sein.",
          },
          invalidData: {
            title: "Ungültige Daten erkannt",
            text: "Einige Zeilen enthalten fehlende oder ungültige Werte. Stellen Sie sicher, dass die Spalte <code>date</code> das Format <strong>YYYY-MM-DD</strong> verwendet und die anderen Spalten gültige Gleitkommawerte (Float) enthalten.",
          },
          invalidDataSequence: {
            title: "Ungültige Datumsfolge",
            text: "Die Daten müssen streng aufsteigend und eindeutig sein. Bitte korrigieren Sie Ihre Datei und versuchen Sie es erneut.",
          },
          parseFail: {
            title: "Verarbeitung fehlgeschlagen",
            text: "Die CSV-Datei konnte nicht korrekt gelesen werden. Bitte überprüfen Sie das Format und versuchen Sie es erneut. Falls das Problem weiterhin besteht, kontaktieren Sie das Alquant-Team.",
          },
          unexpectedError: {
            title: "Unerwarteter Fehler",
            text: "Bei der Verarbeitung Ihrer Datei ist ein unerwarteter Fehler aufgetreten. Bitte kontaktieren Sie das Alquant-Team für Unterstützung.",
          },
        },
      },
    },
  },
  mirante: {
    redirectButtonNavBarText: "Startseite MFM",
  },
};
